import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-filled-blue.svg';
import BottomDrawer from '../../Drawer/Drawer';
import SfhSecondaryButton from '../SellWizard/SfhSecondaryButton';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 0;
  text-align: center;
`;

const DrawerIconWrapper = styled.div`
  > svg {
    width: 48px;
    height: 48px;
  }
`;

const DrawerTitle = styled.h3`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  color: ${themeColors.colorTextPrimary};
  margin: 0;
`;

const DrawerDescription = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: ${themeColors.colorTextSecondary};
  margin: 0;
  white-space: pre-line;
`;

const PhoneLink = styled.a`
  color: ${themeColors.colorPrimary};
  text-decoration: underline;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
`;

const DrawerFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  > button {
    width: 100%;
  }
`;

const PendingAccountVerificationDrawer = ({
  isOpen,
  onClose,
  title,
  description,
  dataCyPrefix = 'button-sfh-pending-verify',
}) => {
  const { t } = useTranslation();

  const resolvedTitle = title || t('restriction.pendingVerification.title');
  const resolvedDescription =
    description || t('restriction.pendingVerification.description');

  const footer = (
    <DrawerFooter>
      <SfhSecondaryButton onClick={onClose} data-cy={`${dataCyPrefix}-close`}>
        {t('restriction.pendingVerification.doItLater')}
      </SfhSecondaryButton>
    </DrawerFooter>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      footer={footer}
      maxHeight="70%"
    >
      <DrawerContent>
        <DrawerIconWrapper>
          <InfoIcon />
        </DrawerIconWrapper>

        <DrawerTitle>{resolvedTitle}</DrawerTitle>

        <DrawerDescription style={{ justifyContent: 'center' }}>
          {resolvedDescription}
        </DrawerDescription>

        <PhoneLink
          href={`tel:${t('restriction.pendingVerification.phoneNumber')}`}
        >
          {t('restriction.pendingVerification.needHelp')}{' '}
          {t('restriction.pendingVerification.phone')}
        </PhoneLink>
      </DrawerContent>
    </BottomDrawer>
  );
};

PendingAccountVerificationDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  dataCyPrefix: PropTypes.string,
};

export default PendingAccountVerificationDrawer;
